import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';

function Portal(_ref) {
  var children = _ref.children,
    _ref$containerSelecto = _ref.containerSelector,
    containerSelector = _ref$containerSelecto === void 0 ? 'body' : _ref$containerSelecto;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    rootElement = _useState2[0],
    setRootElement = _useState2[1];
  useLayoutEffect(function () {
    var container = document.querySelector(containerSelector);
    var root = document.createElement('div');
    container === null || container === void 0 || container.appendChild(root);
    setRootElement(root);
    return function () {
      container === null || container === void 0 || container.removeChild(root);
      setRootElement(null);
    };
  }, []);
  return rootElement ? /*#__PURE__*/createPortal(children, rootElement) : null;
}

export { Portal as default };
//# sourceMappingURL=Portal.js.map
